import { AuthGuard, Layout } from "@adafia/ui";
import { Route, useLocation } from "react-router-dom";
import "./App.css";

import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "../components/AppRoutes";
import { PublicResume } from "./components/PublicResume";
import { ResumeEditor } from "./components/ResumeEditor";
import { ResumeList } from "./components/ResumeList";

function ResumeAppContent() {
	const location = useLocation();
	const isPublicRoute = location.pathname.startsWith("/public/");

	return (
		<Layout currentApp="resume" hideFooter={true} isPublicRoute={isPublicRoute}>
			<div className="app-wrapper">
				<AppRoutes>
					{/* Public Route */}
					<Route path="/public/:slug" element={<PublicResume />} />

					{/* Protected Routes */}
					<Route
						path="/"
						element={
							<AuthGuard>
								<ResumeList />
							</AuthGuard>
						}
					/>
					<Route
						path="/:slug"
						element={
							<AuthGuard>
								<ResumeEditor />
							</AuthGuard>
						}
					/>
				</AppRoutes>
			</div>
		</Layout>
	);
}

export default function App() {
	return (
		<BrowserRouter basename="/resumes">
			<ResumeAppContent />
		</BrowserRouter>
	);
}
